<template>
  <div class="task-options">
    <div v-for="card in optionsCards" :key="card.title">
      <task-options-card
        :title="card.title"
        :icon="card.icon"
        :action-for-get-data="card.actionForGetData"
        :action-for-update-data="card.actionForUpdateData"
        :init-data="card.initData"
        :limits-type="card.limitsType"/>
      <template v-for="(switchCard, index) in switchCardsList">
        <switch-card
          v-if="card.limitsType === switchCard.cardAffiliation"
          :key="index"
          :action-for-get-data="() => getPermissions(switchCard.title)"
          :action-for-update-data="editPermissions"
          :type="switchCard.title"/>
      </template>
    </div>
  </div>
</template>

<script>
import TaskOptionsCard from '@/components/Pages/Tasks/TaskOptionsCard'
import { mapActions, mapGetters } from 'vuex'
import '@/assets/sass/style/components/pages/settings/switchCard.scss'
import SwitchCard from '@/components/Pages/Settings/SwitchCard/SwitchCard'

export default {
  name: 'TaskOptions',
  components: {
    TaskOptionsCard,
    SwitchCard
  },
  data: () => ({
    switchCardsList: [
      {
        title: 'allowTaskPublic',
        cardAffiliation: 'time-limits'
      },
      {
        title: 'enableGmailTask',
        cardAffiliation: 'costs'
      },
      {
        title: 'enableSharingAccount',
        cardAffiliation: 'time-limits'
      }
    ]
  }),
  computed: {
    ...mapGetters([
      'taskOptionsCosts',
      'taskOptionsTimeLimits',
      'allowNextPublication'
    ]),
    optionsCards() {
      return [
        {
          title: 'Суммы начислений',
          icon: { icon: 'nc-money-coins', color: 'icon-success', iconClass: true },
          actionForGetData: this.getOptionsList,
          actionForUpdateData: this.editOptionsList,
          initData: this.taskOptionsCosts,
          limitsType: 'costs'
        },
        {
          title: 'Время модерации',
          icon: { icon: 'AlarmClock', color: 'icon-primary' },
          actionForGetData: this.getOptionsList,
          actionForUpdateData: this.editOptionsList,
          initData: this.taskOptionsTimeLimits,
          limitsType: 'time-limits'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'getOptionsList',
      'editOptionsList'
    ]),
    ...mapActions({
      getPermissions: 'superadministrator/getPermissions',
      editPermissions: 'superadministrator/editPermissions',
    })
  }
}
</script>

<style scoped>

</style>
